import { unescape } from 'lodash-es';

export const getRelByUrl = (url: string) => {
  let rel = 'noopener noreferrer';

  if (['?', '#', '&'].some(item => url.includes(item))) {
    rel += ' nofollow';
  }

  return rel;
};

export const getUrlQuery = (name: string) => {
  const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
  const matches = window.location.search.substring(1).match(reg);

  if (matches !== null) {
    return unescape(matches[2]);
  } else {
    return null;
  }
};
